<template>
    <v-container class="pa-0 mt-4">
        <v-layout row :wrap="$bp.xs">
            <v-flex style="margin-top:-24px;">
                <v-data-table
                    :headers="headers"
                    :items="tokens || []"
                    :loading="table_loader"
                    hide-actions
                    :no-data-text="table_loader ? $t('lang.loading') : $t('lang.no_data_available')"
                >
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.company }}</td>
                        <td>{{ props.item.access_token }}</td>
                        <td class="text-center" :class="!props.item.date_revoked ? 'green--text' : false">{{ props.item.date_issued }}</td>
                        <td class="red--text text-center">{{ props.item.date_revoked }}</td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            headers: [
                { text: this.$t('lang.company_id'), sortable: false },
                { text: this.$t('lang.token_id'), sortable: false },
                { text: this.$t('lang.issued'), sortable: false, align: 'center' },
                { text: this.$t('lang.revoked'), sortable: false, align: 'center' },
            ],
            tokens: null,
            table_loader: true
        };
    },
    activated(){
        if(this.tokens == null){
            this.getUserTokens();
        }
    },
    computed: {
        ...mapGetters(['person']),
    },
    methods: {
        getUserTokens() {
            this.table_loader = true;
            this.$store.dispatch(
                "fetchUserTokens",
                {
                    url: 'people/' +this.person.people_id+ '/user_tokens',
                    method: 'get',
                }
            ).then((data) => {
                if ( typeof(data) !== 'undefined' )
                {
                    this.tokens = data.user_tokens;
                }
            }).finally(() => {
                this.table_loader = false;
            })
        },
    }
};
</script>